import posthog from "posthog-js";

export interface ReferralEvent {
  event: string;
  userId?: string;
  referralCode?: string;
  referredUserId?: string;
  metadata?: Record<string, any>;
}

// Analytics tracking for referral events
export function trackReferralEvent(event: ReferralEvent): void {
  // Log to console for development
  console.log("Referral Event:", event);

  // PostHog capture
  posthog.capture(event.event, {
    user_id: event.userId,
    referral_code: event.referralCode,
    referred_user_id: event.referredUserId,
    ...event.metadata,
  });

  // In production, this would send to your analytics service
  // Example: analytics.track(event.event, event);

  // Store in localStorage for debugging
  try {
    const existingEvents = JSON.parse(
      localStorage.getItem("referral_events") || "[]"
    );
    existingEvents.push({
      ...event,
      timestamp: new Date().toISOString(),
    });
    localStorage.setItem("referral_events", JSON.stringify(existingEvents));
  } catch (error) {
    console.error("Error storing referral event:", error);
  }
}

export const ReferralEvents = {
  CODE_GENERATED: "referral_code_generated",
  SHARED_LINKEDIN: "referral_shared_linkedin",
  LINK_COPIED: "referral_link_copied",
  CODE_ENTERED: "referral_code_entered",
  CODE_VALIDATED: "referral_validated",
  CODE_REJECTED: "referral_rejected",
  CREDIT_EARNED: "referral_credit_earned",
  REPORT_COMPLETED: "referral_report_completed",
} as const;

// Marketing analytics events for campaign tracking
export interface MarketingEvent {
  event: string;
  userId?: string;
  properties?: Record<string, any>;
}

export const MarketingEvents = {
  WIZARD_STARTED: "wizard_started",
  STEP_COMPLETED: "step_completed",
  REPORT_GENERATED: "report_generated",
  USER_REGISTERED: "user_registered",
  PAGE_VIEW: "page_view",
  REFERRAL_SHARED: "referral_shared",
  FORM_ABANDONED: "form_abandoned",
  LOGIN_COMPLETED: "login_completed",
} as const;
